import React, { useState, Fragment } from "react";
import RateRender from "../../../../Common/RateRender";
import CustomModal from "../../../../Common/Modal/CustomModal";
import { FormRateSubmit } from "../Services";
import StarRating from "../../../../Common/Rate/StarRating";
function Index({ ItemOptions }) {
  return (
    <Fragment>
      {/* <CustomModal
          show={state.modal}
          handleClose={handleClose}
          header={"ثبت نظر"}
          children={
            <SubmitRate
              data={ItemOptions}
              set={SubmitHandler}
              state={state}
              setstate={setstate}
              handler={handler}
            />
          }
        /> */}
      {/* <button
          type="button"
          onClick={() => setstate({ ...state, modal: true })}
          className="ms-auto d-flex shadow align-items-center px-3 py-1 btn btn-red pure-input btn-red text-white "
        >
          ثبت نظر
        </button> */}
    </Fragment>
  );
}

export default Index;
